import { config } from "./config";
import axios from "axios";
import { handleAxiosError } from "./utils/error.utils";
import { UnexpectedAPIError } from "./errors";
export const metadata = (() => {
    async function get() {
        try {
            const result = await axios.get(baseUrl());
            return result.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function update(metdata) {
        try {
            const result = await axios.put(baseUrl(), metdata);
            return result.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function remove() {
        try {
            const result = await axios.delete(baseUrl());
            if (result.status === 200)
                return;
            return;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    function baseUrl() {
        return `${config.fullUrl()}/metadata`;
    }
    return {
        get: get,
        update: update,
        delete: remove,
    };
})();
